var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorfulSemicircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 78,
    viewBox: "0 0 118 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23355 31.0246C5.47566 21.0748 5.59504 10.5469 8.57786 0.662131",
    stroke: "#FE9700",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.511 58.1955C17.176 51.0602 11.1602 41.5995 8.23392 31.0249",
    stroke: "#25C5D9",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.26 70.8758C60.644 71.8623 52.9059 71.2438 45.5434 69.0599C38.1809 66.8761 31.357 63.1752 25.5108 58.1955",
    stroke: "#42A4F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7029 58.6009C88.6306 65.449 78.7555 69.8255 68.2601 71.2061",
    stroke: "#EB407A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.731 32.5343C110.702 42.6904 104.786 51.7469 96.7029 58.6008",
    stroke: "#673BB6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.258 32.7083C115.187 32.9443 115.048 33.1541 114.858 33.311C114.668 33.4679 114.435 33.565 114.19 33.5899C113.945 33.6148 113.698 33.5665 113.48 33.451C113.262 33.3355 113.084 33.158 112.967 32.9411C112.85 32.7241 112.8 32.4773 112.824 32.232C112.847 31.9867 112.943 31.7538 113.099 31.5628C113.254 31.3718 113.463 31.2313 113.699 31.1591C113.934 31.0868 114.186 31.086 114.422 31.1568C114.739 31.2518 115.005 31.4686 115.161 31.7595C115.318 32.0505 115.353 32.3918 115.258 32.7083Z",
    fill: "white",
    stroke: "#673BB6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5878 59.1719C98.4764 59.5432 98.2574 59.8731 97.9584 60.1199C97.6594 60.3667 97.2939 60.5192 96.9082 60.5581C96.5225 60.597 96.1339 60.5206 95.7916 60.3386C95.4493 60.1565 95.1688 59.877 94.9854 59.5354C94.8021 59.1938 94.7243 58.8056 94.7617 58.4197C94.7992 58.0338 94.9503 57.6678 95.196 57.3679C95.4416 57.0679 95.7707 56.8477 96.1416 56.7349C96.5125 56.6221 96.9085 56.6219 97.2795 56.7343C97.7758 56.8847 98.1923 57.2258 98.4375 57.6827C98.6828 58.1396 98.7368 58.6752 98.5878 59.1719Z",
    fill: "white",
    stroke: "#EB407A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99587 32.5586C9.90259 32.8696 9.71919 33.1459 9.46886 33.3526C9.21853 33.5594 8.91251 33.6873 8.5895 33.7201C8.2665 33.7529 7.94102 33.6892 7.65422 33.5371C7.36741 33.3849 7.13217 33.1511 6.97824 32.8653C6.8243 32.5794 6.75859 32.2543 6.78941 31.9311C6.82023 31.6079 6.94619 31.3011 7.15138 31.0495C7.35657 30.7979 7.63175 30.6128 7.94215 30.5176C8.25254 30.4224 8.5842 30.4213 8.89518 30.5146C9.31219 30.6397 9.66242 30.9253 9.86884 31.3086C10.0753 31.692 10.121 32.1416 9.99587 32.5586Z",
    fill: "white",
    stroke: "#FE9700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7007 71.6138C70.5604 72.0816 70.2845 72.4972 69.9079 72.808C69.5313 73.1188 69.0709 73.311 68.5851 73.3601C68.0992 73.4092 67.6097 73.313 67.1786 73.0838C66.7474 72.8546 66.3939 72.5026 66.1629 72.0724C65.9318 71.6423 65.8336 71.1532 65.8806 70.6671C65.9276 70.1811 66.1178 69.7199 66.4271 69.342C66.7363 68.9641 67.1507 68.6864 67.6178 68.5441C68.0849 68.4018 68.5838 68.4013 69.0512 68.5426C69.3618 68.635 69.651 68.788 69.9022 68.9926C70.1534 69.1972 70.3617 69.4495 70.515 69.735C70.6683 70.0205 70.7637 70.3334 70.7955 70.6559C70.8274 70.9783 70.7951 71.3039 70.7007 71.6138Z",
    fill: "white",
    stroke: "#42A4F5",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4929 58.653C27.3791 59.0324 27.1553 59.3696 26.8499 59.6218C26.5445 59.874 26.1712 60.03 25.7771 60.0701C25.383 60.1101 24.986 60.0324 24.6361 59.8468C24.2861 59.6611 23.9992 59.3759 23.8114 59.0272C23.6236 58.6784 23.5434 58.2818 23.581 57.8875C23.6186 57.4932 23.7723 57.1189 24.0226 56.812C24.2729 56.505 24.6086 56.2791 24.9873 56.163C25.366 56.0468 25.7706 56.0456 26.15 56.1594C26.6588 56.312 27.0861 56.6604 27.3379 57.1281C27.5897 57.5957 27.6455 58.1443 27.4929 58.653Z",
    fill: "white",
    stroke: "#25C5D9",
    strokeWidth: 1.62,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulSemicircle);
export default __webpack_public_path__ + "static/media/colorful-semicircle.4c0af8dc9cb578b3e5bef9ebab449e5c.svg";
export { ForwardRef as ReactComponent };